
<table class="table table-bordered border-top-0" *ngIf="disSolutions.length">
  <thead>
    <tr class="tr-header-edit-asset">
      <th>Product Number</th>
      <th *ngIf="billFromAccounts" width="300">
        <label class="required m-0">Bill From</label>
      </th>
      <th>Installed</th>
      <th>Description</th>
      <th>
        <label class="required m-0">Install Date</label><br><span>(YYYY-MM-DD)</span>
      </th>
      <th width="150">
        <label class="required m-0">Contract Account</label>
      </th>
      <th *ngIf="!individual" width="35" style="width: 35px; position: sticky; right: 0; border: none; background-color: #f2fafd;"></th>
      <th>Consolidate Invoice</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let dis of disSolutions; let i = index" style="font-size: 0.85rem">
      <th>{{ dis.productNumber }}</th>
      <th class="p-0 position-relative" *ngIf="billFromAccounts">
        <select class="select-asset-data" id="billFromBPIDSelect" [disabled]="disSolutions[0].installed || disSolutions[0].statusKey === &quot;sent-to-broker&quot;" [(ngModel)]="disSolutions[0].billFromBPIDId" ngbTooltip="{{getBPID()}}">
          <option *ngFor="let billFromBuilding of billFromAccounts" [ngValue]="billFromBuilding.id" [selected]>{{ billFromBuilding.value.billFromAccName }}</option>
        </select>
      </th>
      <th><span class="badge badge-success mr-2" *ngIf="dis.installed">Installed</span><span *ngIf="!dis.installed">No</span></th>
      <th>{{ dis.productDescription }}</th>
      <th>
        <input class="input-txt-asset w-100" id="installDate" [disabled]="dis.installed || !(dis.internalId === &quot;&quot; || dis.internalId === null || dis.internalId === undefined) || dis.statusKey === &quot;sent-to-broker&quot;" type="text" [(ngModel)]="dis.installDate" (keypress)="dateFormat(&quot;installDate&quot;)" (change)="changeDetected()" maxlength="10">
      </th>
      <th class="p-0 position-relative">
        <select class="select-asset-data" id="contractAccountId" [disabled]="dis.installed || dis.statusKey === &quot;sent-to-broker&quot;" [(ngModel)]="dis.contractAccountId" (change)="changeDetected(&quot;contractAccountId&quot;, i)">
          <option></option>
          <option *ngFor="let itsmContract of itsmContractAccount" [ngValue]="itsmContract.cId">{{ itsmContract.name }} - {{ itsmContract.cId }}</option>
        </select>
      </th>
      <th class="p-0 position-relative">
        <select class="select-asset-data" id="consolidateInvoice" [disabled]="dis.installed || dis.statusKey === &quot;sent-to-broker&quot;" [(ngModel)]="dis.consolidateInvoice" (change)="changeDetected(&quot;consolidateInvoice&quot;, i)">
          <option [ngValue]="false">No</option>
          <option [ngValue]="true">Yes</option>
        </select>
      </th>
      <th *ngIf="!individual" style="width: 35px; position: sticky; right: 0; border: none; background: white;"><a class="font-20 text-red" id="removeDis" *ngIf="!dis.installed" href="javascript:void(0)" (click)="remove(dis.id, dis.productDescription)"><span class="oi oi-trash"></span></a></th>
    </tr>
  </tbody>
</table>